module.exports = __webpack_public_path__ + "media/images/banner/tjt/pc/travel202309_01_770_280_vi-f34d9c1e1c1af4d12cd7c6c5c18b018f.jpg";